import { Box, Flex } from 'components/elements'
import { DetailContainer, DetailWrapper, DetailedCard, InfoColumn, MainWrapCSS } from 'features/incidents/components/style'
import { useEffect, useState, useMemo } from 'react'
import { routes, serviceArrayAssessment, serviceLableAssessments } from 'configs/constants'
import FormWrapper from 'features/auth/components/FormWrapper'
import { CheckBoxInput, Form, Label, userRegHeadingCss } from 'views/style'
import { Button } from 'components/button/Button'
import { useNavigate } from 'react-router-dom'
import { Controller, useForm } from 'react-hook-form'
import { QouteLayout } from 'features/quote/page/GetAQuotes'
import { PlanReviewSummaryProps, ReviewTermsConditionCompDTO } from 'features/quote/components/type'
import { BoxCss, textCss } from 'features/quote/components/GetAQuoteProcess/QuoteReview'
import { buttonCss } from 'features/quote/components/GetAQuoteProcess/CoveragePlan'
import QuoteReviewModal from 'features/quote/components/GetAQuoteProcess/QuoteReviewModal'
import { useSignupByQuote } from 'features/quote/api/signupByQuote'
import { AxiosError } from 'axios'
import { errorMessage, getUpperCase } from 'utils/function'
import { ErrorBox } from 'features/profile/components/EditProfileForm'
import { CircularProgress } from '@mui/material'
import { TERMINOLOGY } from 'utils/enum'

const AffiliateUserQuoteReview = (prop: PlanReviewSummaryProps) => {
  const { quoteUserReg } = prop
  const [openModal, setOpenModal] = useState(false)
  const [submitError, setSubmitError] = useState('')

  const services = useMemo(() => {
    return quoteUserReg?.service || []
  }, [quoteUserReg])

  const navigate = useNavigate()
  //proper box carrier user comp registration
  const { mutate, isLoading } = useSignupByQuote()

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  const { handleSubmit, control, setValue } = useForm()
  const onSubmit = () => {
    if (openModal) {
      handleAccept()
    } else setOpenModal(true)
  }
  const handleAccept = () => {
    setValue('terms', true)
    const services = quoteUserReg?.service
    const skipPayment = true
    const userRegistrationObject = {
      ...quoteUserReg,
      ...quoteUserReg?.users,
      services,
      skipPayment, //it true mean alreay paid
    }

    mutate(userRegistrationObject, {
      onSuccess: data => {
        setOpenModal(false)
        window.location.href = data?.url
      },
      onError: error => {
        if (error instanceof AxiosError) {
          setSubmitError(errorMessage(error))
          setOpenModal(false)
        }
      },
    })
  }
  return (
    <>
      <Flex align="start" justify="center" css={{ ...QouteLayout, mt: '$12', mb: '$12' }}>
        <FormWrapper controlWidth={{ maxWidth: 700 }} css={{ background: '$white77' }} isCardBackgroundNone={true}>
          <Flex align="center" css={{ alignItems: 'center' }}>
            <Flex as="h2" justify={'center'} css={{ ...userRegHeadingCss, color: '$black39' }}>
              Quote Review
            </Flex>
          </Flex>

          <Form onSubmit={handleSubmit(onSubmit)}>
            <Box css={{ textAlign: 'left' }}>
              <Box as="p" css={{ fontSize: '1rem', fontWeight: '$normal', color: '$black00' }}>
                Based on your selection, following are your {TERMINOLOGY.warranty.singular.toLowerCase()} details
              </Box>
              {prop?.quoteReview?.insurancePlan && (
                <Box className="detail-box" style={{ padding: 0 }} css={{ ...MainWrapCSS, background: '$white', borderRadius: '8px' }}>
                  <DetailedCard css={{ maxWidth: 'none', marginBottom: 0, border: '3px solid $gray14' }}>
                    <Flex justify="start" direction="column">
                      <DetailWrapper css={{ border: 'none', p: 0, color: '$black00 !important' }}>
                        <Flex justify={'between'} wrap={'wrap'} css={{ mb: '$3' }}>
                          <Box as="h4" css={{ textAlign: 'start', m: 0 }}>
                            {TERMINOLOGY.warranty.singular} details
                          </Box>
                        </Flex>
                        <DetailContainer css={{ ...InnerBorderCss, background: '$gray15' }}>
                          <InfoColumn css={BoxCss}>
                            <Box as="p" className="affiliateReview  m-0 t-box">
                              {TERMINOLOGY.warranty.singular}
                            </Box>
                            <Box as="p" className={`t-value `} css={textCss}>
                              {prop?.quoteReview?.insurancePlan?.label}
                            </Box>
                          </InfoColumn>
                          <InfoColumn css={BoxCss}>
                            <Box as="p" className="affiliateReview  m-0">
                              {TERMINOLOGY.benefit.singular}
                            </Box>
                            <Box as="p" className={`t-value `} css={textCss}>
                              ${prop?.quoteReview?.insurancePlan?.maxCoverage}
                            </Box>
                          </InfoColumn>
                          <InfoColumn css={BoxCss}>
                            <Box as="p" className="affiliateReview  m-0">
                              Original Premium{' '}
                            </Box>
                            <Box as="p" className={`t-value `} css={textCss}>
                              ${prop?.quoteReview?.insurancePlan?.premiumAmount}
                            </Box>
                          </InfoColumn>
                          <InfoColumn css={BoxCss}>
                            <Box as="p" className="affiliateReview  m-0">
                              Discounted Premium
                            </Box>
                            <Box as="p" className={`t-value `} css={{ ...textCss, color: '$primaryMain', fontSize: '$xl' }}>
                              $0
                            </Box>
                          </InfoColumn>
                        </DetailContainer>
                      </DetailWrapper>
                    </Flex>
                    <Flex justify={'start'} direction={'column'} css={{ mt: '$5' }}>
                      <Box as="h3" css={{ textAlign: 'start', fontSize: '1rem', fontWeight: '$normal', color: '$black00', margin: 0 }}>
                        Monitoring services
                      </Box>
                      <Box css={{ textAlign: 'start' }}>
                        <Flex direction={'column'} wrap={'wrap'}>
                          {services?.map((item, idx) => {
                            const serviceName = serviceArrayAssessment[item - 1]
                            return (
                              <Flex direction={'row'} key={idx} wrap={'wrap'} css={{ width: '100%', padding: '.5rem' }}>
                                <Box as="span" css={{ fontWeight: '$bold', fontSize: '$1rem', flexBasis: '40%', color: '$gray8' }}>
                                  {serviceLableAssessments[serviceName]}
                                </Box>
                                <Box as="span" css={{ flexBasis: '50%', color: '$black00', fontWeight: '$medium' }}>
                                  {serviceName}
                                </Box>
                              </Flex>
                            )
                          })}
                        </Flex>
                      </Box>
                    </Flex>
                  </DetailedCard>
                </Box>
              )}
            </Box>
            {!!submitError && <ErrorBox css={{ textAlign: 'left', mb: '$3' }}>{getUpperCase(submitError)}</ErrorBox>}

            <ReviewTermsConditionComp control={control} setOpenModal={setOpenModal} color={'$background'} border={'3px solid $gray16 !important'} />
            <Box css={buttonCss}>
              <Button bordered={false} type="button" onClick={() => navigate(routes.login)}>
                Cancel
              </Button>
              <Button type="submit" color={'secondary'} disabled={isLoading}>
                {isLoading ? (
                  <>
                    <CircularProgress size={19} sx={{ color: 'var(--colors-white)' }} />
                  </>
                ) : (
                  'Accept'
                )}
              </Button>
            </Box>
          </Form>
        </FormWrapper>

        <QuoteReviewModal openModal={openModal} setOpenModal={setOpenModal} handleAccept={handleAccept} background={'#373946CC'} isLoading={isLoading} />
      </Flex>
    </>
  )
}

export const ReviewTermsConditionComp = (props: ReviewTermsConditionCompDTO) => {
  const { control, color, border } = props
  return (
    <Flex>
      <Box>
        <Label>
          <Controller
            name="terms"
            control={control}
            render={({ field }) => (
              <CheckBoxInput
                type="checkbox"
                css={{
                  width: '20px !important',
                  height: '20px !important',
                  borderRadius: '4px !important',
                  flexShrink: 0,
                  border: border,
                }}
                data-state={field.value ? 'checked' : 'unchecked'}
                onChange={() => field.onChange(!field.value)}
              />
            )}
          />

          <Box as="p" css={{ textAlign: 'left', color: color }}>
            By checking the box and pressing [“Agree”], I acknowledge&nbsp;
            <Box as="a" href="/privacy-policy.html" target="_blank" rel="noopener noreferrer" css={{ fontWeight: '$bold', textDecoration: 'underline', color: color }}>
              DLT Alert’s PRIVACY POLICY
            </Box>{' '}
            and agree to&nbsp; DLT Alert’s TERMS OF SERVICE including the arbitration provision linked&nbsp;
            <Box as="a" href="/terms-of-service.html" target="_blank" rel="noopener noreferrer" css={{ fontWeight: '$bold', textDecoration: 'underline', color: color }}>
              here
            </Box>{' '}
          </Box>
        </Label>
      </Box>
    </Flex>
  )
}
export const InnerBorderCss = {
  border: '2px solid $gray14',
}

export default AffiliateUserQuoteReview
